module.exports = __webpack_public_path__ + "static/media/skytrain.36399af8.jpg";